module.exports = __webpack_public_path__ + "static/media/icomoon.c3d6163f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.woff?hujj0d
// module id = ./src/assets/fonts/icomoon.woff?hujj0d
// module chunks = 23